import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'small-sidebar',
  standalone: true,
  imports: [
    LucideAngularModule,
    CommonModule,
    RouterLink
  ],
  templateUrl: './small-sidebar.component.html',
  styleUrl: './small-sidebar.component.css'
})
export class SmallSidebarComponent {
  icons = Icons;
  pageRoute: string = '';

  @Input() sidebarStatus: string = '';  
  @Output() sidebarStatusChange = new EventEmitter<string>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.updatePageRoute();
    });
    this.updatePageRoute();
  }

  private updatePageRoute() {
    const url = this.router.url.replace(/\/+$/, ''); // remove trailing slash
    const segments = url.split('/');
    this.pageRoute = segments[1];
  }
  
  navigateToPage(route: string): void {
    this.router.navigate([route]);
  }

  toggleSidebar(): void {
    this.sidebarStatus = this.sidebarStatus === 'small' ? 'large' : 'small';
    this.sidebarStatusChange.emit(this.sidebarStatus);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.pageRoute = this.activatedRoute.snapshot.firstChild?.routeConfig?.path ?? '';
    });
  }
}
